import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output
} from '@angular/core';


@Component({
  selector: 'ppl-sign-in-completed',
  standalone: false,
  templateUrl: './sign-in-completed.component.html',
  styleUrl: './sign-in-completed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInCompletedComponent {
  @Output() action = new EventEmitter();

  onAction() {
    this.action.emit();
  }
}
